import { api } from "@/lib/api";

/** Composes the live WebGL frame with a branded caption strip and returns an image blob. */
export const composeSnapshot = async (glCanvas, { board, stone, handle, finish }, type = "image/png", quality) => {
  const W = 1600, H = Math.round((glCanvas.height / glCanvas.width) * W), BAR = 150;
  const c = document.createElement("canvas");
  c.width = W; c.height = H + BAR;
  const ctx = c.getContext("2d");
  ctx.drawImage(glCanvas, 0, 0, W, H);
  ctx.fillStyle = "#0D0D11"; ctx.fillRect(0, H, W, BAR);
  ctx.fillStyle = "#D4AF37"; ctx.fillRect(0, H, W, 2);

  const host = window.location.host.toUpperCase();
  ctx.font = "italic 34px 'Cormorant Garamond', serif"; const brandW = ctx.measureText("Sterling Joinery").width;
  ctx.font = "15px 'JetBrains Mono', monospace"; const hostW = ctx.measureText(host).width;
  const cols = [["Board", board?.name], ["Stone", stone?.name], ["Handle", handle ? [handle.name, finish].filter(Boolean).join(" · ") : null]];
  const colW = (W - 120 - Math.max(brandW, hostW) - 60) / 3;
  cols.forEach(([label, value], i) => {
    const x = 60 + i * colW;
    ctx.fillStyle = "#C5A059"; ctx.font = "500 15px 'JetBrains Mono', monospace"; ctx.fillText(label.toUpperCase(), x, H + 56);
    ctx.fillStyle = "#F5F3EF"; ctx.font = "24px 'Outfit', sans-serif";
    let v = value || "—";
    while (ctx.measureText(v).width > colW - 30 && v.length > 4) v = v.slice(0, -2).trimEnd() + "…";
    ctx.fillText(v, x, H + 96);
  });
  ctx.textAlign = "right";
  ctx.fillStyle = "#F5F3EF"; ctx.font = "italic 34px 'Cormorant Garamond', serif"; ctx.fillText("Sterling Joinery", W - 60, H + 66);
  ctx.fillStyle = "#A09E97"; ctx.font = "15px 'JetBrains Mono', monospace"; ctx.fillText(host, W - 60, H + 100);
  return new Promise((res) => c.toBlob(res, type, quality));
};

/** Uploads a JPEG of the current view for use in quote emails; resolves to its /api/files URL. */
export const uploadSnapshot = async (glCanvas, pair) => {
  const blob = await composeSnapshot(glCanvas, pair, "image/jpeg", 0.85);
  const fd = new FormData();
  fd.append("file", blob, "pairing.jpg");
  const { data } = await api.post("/snapshots", fd);
  return data.url;
};

export const snapshotFilename = ({ board, stone }) =>
  `sterling-pairing-${[board?.name, stone?.name].filter(Boolean).join("-").toLowerCase().replace(/[^a-z0-9]+/g, "-") || "kitchen"}.png`;
